import { render, staticRenderFns } from "./HedgingCostsForwardsInterbankRatesTableBlock.vue?vue&type=template&id=3e07e6cd"
import script from "./HedgingCostsForwardsInterbankRatesTableBlock.vue?vue&type=script&lang=js"
export * from "./HedgingCostsForwardsInterbankRatesTableBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VDataTable})
